import {

  FETCH_START,
  FETCH_END,
  CHANGE_MANAGEMENT_LIST_DATA_SUCCESS,
  CHANGE_MANAGEMENT_SINGLE_DATA_SUCCESS,
  CHANGE_MANAGEMENT_DROP_DATA_SUCCESS,
  CHANGE_MANAGEMENT_TABLE_DATA_SUCCESS,
  CHANGE_MANAGEMENT_COUNT_SUCCESS,
  CHANGE_MANAGEMENT_RECORD_SUCCESS,
  CHANGE_MANAGEMENT_RECORD_CLEAR
} from '../../../actions/DesignerStudio/ChangeManagement/ActionTypes'

const initialState = {
  loading: false,
  changeMgmtListData: [],
  changeMgmtSingleData: [],
  dropdownChangeMgmt: [],
  changeMgmtTable: [],
  changeMgmtCount: [],
  changeMgmtRecord: null
};

const ChangeManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case CHANGE_MANAGEMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        changeMgmtListData: action.data
      }
    case CHANGE_MANAGEMENT_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        changeMgmtSingleData: action.data
      };
    case CHANGE_MANAGEMENT_DROP_DATA_SUCCESS:
      return {
        ...state,
        dropdownChangeMgmt: action.data
      };
    case CHANGE_MANAGEMENT_TABLE_DATA_SUCCESS:
      return {
        ...state,
        changeMgmtTable: action.data
      };
    case CHANGE_MANAGEMENT_COUNT_SUCCESS:
      return {
        ...state,
        changeMgmtCount: action.data
      }
    case CHANGE_MANAGEMENT_RECORD_SUCCESS:
      return {
        ...state,
        changeMgmtRecord: action.data
      };
    case CHANGE_MANAGEMENT_RECORD_CLEAR:
      return {
        ...state,
        changeMgmtRecord: null
      };
    default:
      return state;
  }
};

export default ChangeManagementReducer;
